import React, { useEffect } from "react"
import { isSafari } from "helpers/util"
import { useHistory } from "react-router-dom"
import "styles/pages/info-page.scss"

const InfoPage = () => {
  let history = useHistory()
  useEffect(() => {
    if (!isSafari()) {
      history.push("/")
    }
  }, [history])

  return (
    <section className="info-section">
      <h1 className="title">Oh snap!</h1>
      <p className="subtitle">
        Apptitude is not fully supported in this browser. Please open in Google
        Chrome or Chromium browser.
      </p>
    </section>
  )
}

export default InfoPage
